import { LoadingSpinner } from '../../Components/Molecules/LoadingUI';
import Modal from '../../Components/Organisms/Modal';
import SuCross from '@meronex/icons/su/SuCross';
import IosArrowForward from '@meronex/icons/ios/IosArrowForward';
import Pagination from '../../Components/Molecules/Pagination';
import useData from './data';
import EnquiryItem from './EnquiryItem';
import UploadInvoiceModal from './UploadInvoiceModal';
import NotInterestedModal from './NotInterestedModal';
import { useHistory } from 'react-router-dom';
import SideModal from '../../Components/Organisms/SideModal';
import { getConfig } from '../../utils/config';
import GrClose from '@meronex/icons/gr/GrClose';
import { isRentalVisible } from '../../utils/routing';

const statusList = [
    { label: 'Not Interested', id: 'NOT_INTERESTED' },
    { label: 'Enquired', id: 'ENQUIRED' },
    { label: 'Purchased', id: 'PURCHASE_CONFIRMED' }
];

const categoryList = [
    { name: 'All', id: null },
    {
        name: 'Loans',
        id: 3
    },
    {
        name: 'Move In',
        id: 2
    },
    {
        name: 'Lifestyle',
        id: 1
    },
    isRentalVisible && {
        name: 'Rentals',
        id: -1
    }
    // {
    //     name: 'Cashback'
    // },
    // {
    //     name: 'Rewards'
    // }
];

function Enquiry() {
    const history = useHistory();
    const {
        state: {
            isAuthenticated,
            showBlockedBrands,
            summaryLoading,
            summary,
            enquiries,
            enquiryLoading,
            enquiryError,
            totalPages,
            currentPage,
            currentFilters,
            showNotInterestedModal,
            showInvoiceModal,
            selectedDealId,
            selectedEnquiryId,
            updateStatusLoading,
            showFilterModal,
            currentCategory,
            tags,
            currentTags
        },
        openLoginModal,
        accessToken,
        setShowBlockedBrands,
        setCurrentPage,
        onFilterClick,
        setNotInterestedModalVisibility,
        setInvoiceModalVisibility,
        setSelectedDealId,
        updateStatus,
        onRefresh,
        updateInvoice,
        onReopen,
        setShowFilterModal,
        onCategoryClick,
        clearAll,
        onTagClick,
        setSelectedEnquiryId
    } = useData();

    const config = getConfig();

    const getTotalEnquiries = (summaryObj) => {
        return Object.keys(summaryObj)
            .filter((type) => type !== 'totalCashback')
            .reduce((acc, curr) => {
                return acc + (summaryObj[curr] || 0);
            }, 0);
    };

    // console.log(showNotInterestedModal, showInvoiceModal);

    return (
        <>
            {!isAuthenticated && !accessToken && (
                <div className="py-12 flex justify-center">
                    <button
                        onClick={openLoginModal}
                        className="self-start bg-primary text-white py-2 px-6 rounded-lg hover:shadow-xl "
                    >
                        Login to access your Enquiries
                    </button>
                </div>
            )}
            {!isAuthenticated && accessToken && (
                <div className="h-screen">
                    <LoadingSpinner />
                </div>
            )}
            {isAuthenticated && (
                <div className="w-full lg:pl-5 2xl:pl-7">
                    <div className="flex justify-between">
                        <div>
                            <h1 className=" font-Poppins text-xl md:text-2xl font-bold">
                                Claim Your Cashback
                            </h1>
                            <h3 className=" font-Poppins pt-1 text-sm">
                                Track your ongoing enquires and claim your
                                rewards
                            </h3>
                        </div>
                    </div>
                    <div className="mt-5 lg:mt-7 flex flex-wrap justify-between lg:justify-start lg:gap-x-4 xl:gap-x-6">
                        <div className="flex  bg-[#F5F5F5] lg:bg-transparent rounded w-full lg:w-[50%] justify-between border-[2px] border-[#EDEDED]">
                            <div
                                className={`gap-x-4 pl-5 py-5 w-1/3 ${
                                    currentFilters.length === 0
                                        ? 'bg-[#F4F4F4]'
                                        : ''
                                } hover:bg-[#E5E5E5] cursor-pointer`}
                                onClick={() =>
                                    onFilterClick({ removeAll: true })
                                }
                            >
                                <div className="text-sm w-full border-r-2 border-[#EDEDED] background-grey">
                                    <h4 className="text-xl font-bold">
                                        {summaryLoading || !summary
                                            ? '-'
                                            : getTotalEnquiries(summary) || '-'}
                                    </h4>
                                    <p>Total</p>
                                    <p>Enquiries</p>
                                </div>
                            </div>
                            <div
                                className={`gap-x-4 pl-5 py-5 w-1/3 ${
                                    currentFilters.includes('INVOICE_IN_REVIEW')
                                        ? 'bg-[#F4F4F4]'
                                        : ''
                                } hover:bg-[#E5E5E5] cursor-pointer`}
                                onClick={() =>
                                    onFilterClick({
                                        status: 'INVOICE_IN_REVIEW'
                                    })
                                }
                            >
                                <div className="text-sm w-full border-r-2 border-[#EDEDED]">
                                    <h4 className="text-xl font-bold">
                                        {summaryLoading || !summary
                                            ? '-'
                                            : summary.invoiceInReview || '-'}
                                    </h4>
                                    <p>Invoice</p>
                                    <p>Submitted</p>
                                </div>
                            </div>
                            <div
                                className={`gap-x-4 pl-5 py-5 w-1/3 ${
                                    currentFilters.includes(
                                        'PURCHASE_CONFIRMED'
                                    )
                                        ? 'bg-[#F4F4F4]'
                                        : ''
                                } hover:bg-[#E5E5E5] cursor-pointer`}
                                onClick={() =>
                                    onFilterClick({
                                        status: 'PURCHASE_CONFIRMED'
                                    })
                                }
                            >
                                <div className="text-sm w-full">
                                    <h4 className="text-xl font-bold">
                                        {summaryLoading || !summary
                                            ? '-'
                                            : summary.purchaseConfirmed || '-'}
                                    </h4>
                                    <p>Cashback</p>
                                    <p>Approved</p>
                                </div>
                            </div>
                        </div>
                        {/* <div
                            onClick={() => setShowBlockedBrands(true)}
                            className="mt-5 lg:mt-0 cursor-pointer p-5 rounded text-sm w-[48%] lg:w-[20%] xl:w-[15%] text-white bg-[#F02106]"
                        >
                            <h4 className="text-xl font-bold">03</h4>
                            <div className="flex justify-between items-end">
                                <div className="">
                                    <p>Brands</p>
                                    <p>Blocked</p>
                                </div>
                                <div className="bg-[#ffffff33] h-7 w-7 rounded">
                                    <IosArrowForward className="h-full m-auto" />
                                </div>
                            </div>
                        </div> */}
                        <div className="p-5 rounded text-sm w-[100%] sm:w-[100%] lg:w-[22%] xl:w-[20%] text-white bg-primary mt-5 lg:mt-0 ">
                            <h4 className="text-xl font-bold">
                                {summaryLoading || !summary
                                    ? '-'
                                    : summary.totalCashback || '-'}
                            </h4>
                            <div className="flex justify-between items-end">
                                <div className="">
                                    <p>Total</p>
                                    <p>Cashback</p>
                                </div>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="32"
                                    height="32.002"
                                    viewBox="0 0 32 32.002"
                                >
                                    <g
                                        id="_7._Wallet"
                                        data-name="7. Wallet"
                                        transform="translate(0 0.002)"
                                        opacity="0.3"
                                    >
                                        <path
                                            id="Path_6400"
                                            data-name="Path 6400"
                                            d="M30,15.18V11a3,3,0,0,0-3-3H25.5L19.8.4A1,1,0,0,0,18.41.19L13.35,3.88A6,6,0,0,0,3,8a3,3,0,0,0-3,3V29a3,3,0,0,0,3,3H27a3,3,0,0,0,3-3V24.82A3,3,0,0,0,32,22V18A3,3,0,0,0,30,15.18ZM18.79,2.39,23,8H11.08ZM9,4a4,4,0,0,1,2.71,1.06L7.67,8H5A4,4,0,0,1,9,4ZM27,30H3a1,1,0,0,1-1-1V11a1,1,0,0,1,1-1H27a1,1,0,0,1,1,1v4H25a5,5,0,0,0,0,10h3v4A1,1,0,0,1,27,30Zm3-8a1,1,0,0,1-1,1H25a3,3,0,0,1,0-6h4a1,1,0,0,1,1,1Z"
                                            fill="#fff"
                                        />
                                        <path
                                            id="Path_6401"
                                            data-name="Path 6401"
                                            d="M25,19h0a1,1,0,1,0,1,1A1,1,0,0,0,25,19Z"
                                            fill="#fff"
                                        />
                                        <path
                                            id="Path_6402"
                                            data-name="Path 6402"
                                            d="M5,12a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V13A1,1,0,0,0,5,12Z"
                                            fill="#fff"
                                        />
                                        <path
                                            id="Path_6403"
                                            data-name="Path 6403"
                                            d="M5,18a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V19A1,1,0,0,0,5,18Z"
                                            fill="#fff"
                                        />
                                        <path
                                            id="Path_6404"
                                            data-name="Path 6404"
                                            d="M5,24a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V25A1,1,0,0,0,5,24Z"
                                            fill="#fff"
                                        />
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                    {/* Tabs */}
                    <div className="mt-7 flex gap-x-2 lg:gap-x-6 lg:border-b-[1.5px] lg:border-gray-200">
                        {categoryList.map((tab, i) => (
                            <button
                                onClick={() => onCategoryClick(tab?.id)}
                                className={`${
                                    currentCategory === tab?.id
                                        ? 'text-white lg:text-primary bg-primary lg:bg-transparent lg:border-b-[3px] lg:border-primary font-semibold'
                                        : 'bg-[#EDEDED] lg:bg-transparent'
                                } text-sm md:text-base rounded-full lg:rounded-none py-1 px-5 lg:px-3 pb-2 font-medium`}
                            >
                                {tab?.name}
                            </button>
                        ))}
                    </div>
                    <div className="mt-10 lg:mt-7 flex justify-between items-center">
                        <div className="flex items-center">
                            <div className="">
                                <div>
                                    <h2 className=" font-Poppins text-xl md:text-xl font-bold">
                                        Enquiries List
                                    </h2>
                                    <h3 className=" font-Poppins pt-1 text-xs">
                                        All your cashback information comes here
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <button
                            className="flex items-center text-primary border-[2px] border-primary py-1 px-3 rounded font-medium"
                            onClick={() => setShowFilterModal(true)}
                        >
                            <svg
                                className="text-primary mr-2"
                                xmlns="http://www.w3.org/2000/svg"
                                width="17.071"
                                height="17.084"
                                viewBox="0 0 17.071 17.084"
                            >
                                <g id="_icons" transform=" rotate(0)">
                                    <path
                                        id="Path_6241"
                                        data-name="Path 6241"
                                        d="M.633,3.165H10a2.526,2.526,0,0,0,2.469,1.9,2.582,2.582,0,0,0,2.469-1.9h1.516a.6.6,0,0,0,.633-.633.6.6,0,0,0-.633-.633H14.935A2.526,2.526,0,0,0,12.466,0,2.582,2.582,0,0,0,10,1.9H.633A.6.6,0,0,0,0,2.532.6.6,0,0,0,.633,3.165Zm11.833-1.9A1.266,1.266,0,1,1,11.2,2.532,1.27,1.27,0,0,1,12.466,1.266Z"
                                        transform="translate(0 6.467)"
                                        fill="currentColor"
                                    />
                                    <path
                                        id="Path_6242"
                                        data-name="Path 6242"
                                        d="M.633,3.165H5.079a2.526,2.526,0,0,0,2.469,1.9,2.582,2.582,0,0,0,2.469-1.9h6.435a.6.6,0,0,0,.633-.633.6.6,0,0,0-.633-.633H10.016A2.526,2.526,0,0,0,7.547,0,2.582,2.582,0,0,0,5.079,1.9H.633A.6.6,0,0,0,0,2.532.6.6,0,0,0,.633,3.165Zm6.914-1.9A1.266,1.266,0,1,1,6.281,2.532,1.27,1.27,0,0,1,7.547,1.266Z"
                                        transform="translate(0)"
                                        fill="currentColor"
                                    />
                                    <path
                                        id="Path_6243"
                                        data-name="Path 6243"
                                        d="M.633,3.165H2.149a2.526,2.526,0,0,0,2.469,1.9,2.582,2.582,0,0,0,2.469-1.9h9.365a.6.6,0,0,0,.633-.633.6.6,0,0,0-.633-.633H7.087A2.526,2.526,0,0,0,4.618,0,2.582,2.582,0,0,0,2.149,1.9H.633A.6.6,0,0,0,0,2.532.6.6,0,0,0,.633,3.165Zm3.985-1.9A1.266,1.266,0,1,1,3.352,2.532,1.27,1.27,0,0,1,4.618,1.266Z"
                                        transform="translate(0 12.007)"
                                        fill="currentColor"
                                    />
                                </g>
                            </svg>
                            Filter
                        </button>
                    </div>
                    {/* Applied Filter */}
                    {(currentTags?.length > 0 ||
                        currentFilters.filter((filter) =>
                            statusList.find((s) => s.id === filter)
                        ).length > 0) && (
                        <div className="bg-[#F5F5F5] p-4 rounded-lg mt-4">
                            <div className="flex justify-between">
                                <h2 className="font-bold">Applied Filters:</h2>
                                <button
                                    className="lg:hidden text-sm md:text-base lg:text-sm xl:text-base text-primary underline font-medium"
                                    onClick={() => clearAll()}
                                >
                                    Clear all
                                </button>
                            </div>
                            <div className="flex justify-between mt-2">
                                <div className="w-full md:w-[75%] flex flex-wrap gap-x-2 gap-y-2">
                                    {currentFilters
                                        .filter((filter) =>
                                            statusList.find(
                                                (s) => s.id === filter
                                            )
                                        )
                                        .map((filter) => (
                                            <button
                                                onClick={() =>
                                                    onFilterClick({
                                                        status: filter
                                                    })
                                                }
                                                className={`text-sm md:text-base lg:text-sm xl:text-base border-[2px] border-primary bg-white text-primary font-medium rounded-2xl py-1 px-3 `}
                                            >
                                                {
                                                    statusList.find(
                                                        (t) => t.id === filter
                                                    ).label
                                                }{' '}
                                                <span className="ml-2 cursor-pointer">
                                                    <GrClose
                                                        // onClick={() => setShowModal(false)}
                                                        className={`inline h-3 w-3 `}
                                                    />
                                                </span>
                                            </button>
                                        ))}
                                    {currentTags.map((tag) => (
                                        <button
                                            onClick={() => onTagClick(tag)}
                                            className={`text-sm md:text-base lg:text-sm xl:text-base border-[2px] border-primary bg-white text-primary font-medium rounded-2xl py-1 px-3 `}
                                        >
                                            {
                                                tags.find((t) => t.id === tag)
                                                    .name
                                            }{' '}
                                            <span className="ml-2 cursor-pointer">
                                                <GrClose
                                                    // onClick={() => setShowModal(false)}
                                                    className={`inline h-3 w-3 `}
                                                />
                                            </span>
                                        </button>
                                    ))}
                                </div>
                                <div className="w-[25%] hidden lg:flex justify-end self-start">
                                    <button
                                        onClick={() => clearAll()}
                                        className={` lg:text-sm xl:text-base border-[2px] border-primary text-primary rounded-full py-1 px-3 font-medium `}
                                    >
                                        Clear all
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {enquiryLoading ||
                    enquiryError ||
                    enquiries?.length === 0 ? (
                        <div className="mt-5 h-[200px] flex justify-center align-middle">
                            {enquiryLoading ? (
                                <div className="flex flex-col justify-center align-item-center w-100">
                                    <LoadingSpinner />
                                </div>
                            ) : enquiryError ? (
                                <div className="flex flex-col justify-center text-center align-item-center w-100">
                                    <p
                                        className={`
                         z-10 mt-6 `}
                                    >
                                        Something Went Wrong
                                    </p>
                                    <button
                                        onClick={onRefresh}
                                        className="bg-primary text-white py-2 px-3 mt-2 rounded"
                                    >
                                        Try Again
                                    </button>
                                </div>
                            ) : (
                                <div className="flex flex-col justify-center align-item-center text-center w-100">
                                    <p
                                        className={`
                         z-10 mt-6 `}
                                    >
                                        No Enquiries Found in the selected
                                        criteria
                                    </p>
                                    <button
                                        onClick={() => history.push('/deals')}
                                        className="bg-primary text-white py-2 px-3 mt-2 rounded"
                                    >
                                        Click Here to Explore Offers
                                    </button>
                                </div>
                            )}
                        </div>
                    ) : (
                        enquiries.map((e) => (
                            <EnquiryItem
                                enquiry={e}
                                setInvoiceModalVisibility={
                                    setInvoiceModalVisibility
                                }
                                setNotInterestedModalVisibility={
                                    setNotInterestedModalVisibility
                                }
                                setSelectedDealId={setSelectedDealId}
                                setSelectedEnquiryId={setSelectedEnquiryId}
                                reopen={onReopen}
                                reopenloading={updateStatusLoading}
                            />
                        ))
                    )}
                    <div className=" flex justify-end mb-7 mt-5">
                        <Pagination
                            scrollTo="blogs_section"
                            totalPages={totalPages}
                            currentPage={currentPage + 1}
                            onPageChange={(p) => setCurrentPage(p - 1)}
                        />
                    </div>
                </div>
            )}
            <Modal
                visible={showBlockedBrands}
                onClick={() => setShowBlockedBrands(false)}
            >
                <div className="px-4 lg:px-8 lg:py-4">
                    <div className="flex justify-between">
                        <div>
                            <h1 className="text-xl lg:text-2xl">Blocked</h1>
                            <h3 className="">You will get a callback at</h3>
                        </div>
                        <SuCross
                            onClick={() => setShowBlockedBrands(false)}
                            className="h-7 w-7 cursor-pointer"
                        />
                    </div>
                    <div className="mt-5 p-3 lg:p-4 flex lg:items-center justify-between rounded border-[2px] border-[#EDEDED]">
                        <div className="flex flex-col lg:flex-row lg:items-center items-start ">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="50"
                                height="50"
                                viewBox="0 0 50 50"
                            >
                                <defs>
                                    <linearGradient
                                        id="linear-gradient"
                                        y1="0.5"
                                        x2="1"
                                        y2="0.5"
                                        gradientUnits="objectBoundingBox"
                                    >
                                        <stop offset="0" stop-color="#ec8523" />
                                        <stop
                                            offset="0.35"
                                            stop-color="#ed7745"
                                        />
                                        <stop
                                            offset="0.37"
                                            stop-color="#ed7545"
                                        />
                                        <stop
                                            offset="0.76"
                                            stop-color="#e95d47"
                                        />
                                        <stop offset="1" stop-color="#e85448" />
                                    </linearGradient>
                                </defs>
                                <g
                                    id="Group_9456"
                                    data-name="Group 9456"
                                    transform="translate(4235.257 -6161)"
                                >
                                    <rect
                                        id="Rectangle_1020"
                                        data-name="Rectangle 1020"
                                        width="50"
                                        height="50"
                                        rx="2"
                                        transform="translate(-4235.257 6161)"
                                        fill="#f4f4f4"
                                    />
                                    <g
                                        id="Group_9406"
                                        data-name="Group 9406"
                                        transform="translate(-4223.126 6170.594)"
                                    >
                                        <path
                                            id="Path_3971"
                                            data-name="Path 3971"
                                            d="M0,0V13.1H12.163V11.563H1.578V1.539H16.519V13.1H18.1V0Z"
                                            transform="translate(4)"
                                            fill-rule="evenodd"
                                            fill="url(#linear-gradient)"
                                        />
                                        <g
                                            id="Group_9394"
                                            data-name="Group 9394"
                                            transform="translate(0 18)"
                                        >
                                            <path
                                                id="Path_3972"
                                                data-name="Path 3972"
                                                d="M2.451,6.386A2.312,2.312,0,0,1,0,3.774V.9H1.1V3.74c0,1.148.5,1.716,1.368,1.716S3.833,4.888,3.833,3.74V.9H4.892V3.764a2.3,2.3,0,0,1-2.441,2.61ZM6.978,4.139v2.1H5.948V2.392h.943l.045.7a1.6,1.6,0,0,1,1.426-.807v1c-.7-.163-1.39.193-1.39.85Zm4.37,2.2a1.735,1.735,0,0,1-1.43-.719l-.036.613H8.951V.9H9.978V2.922a1.741,1.741,0,0,1,1.369-.632,1.874,1.874,0,0,1,1.8,2.027A1.873,1.873,0,0,1,11.348,6.342Zm-.32-3.287A1.13,1.13,0,0,0,9.936,4.316a1.1,1.1,0,1,0,2.182,0A1.13,1.13,0,0,0,11.027,3.055Zm5.958,3.181-.036-.613a1.738,1.738,0,0,1-1.43.719,1.874,1.874,0,0,1-1.8-2.025,1.873,1.873,0,0,1,1.8-2.027,1.739,1.739,0,0,1,1.43.72l.036-.614h.931V6.235h-.931ZM15.839,3.055a1.13,1.13,0,0,0-1.092,1.262,1.1,1.1,0,1,0,2.184,0A1.129,1.129,0,0,0,15.839,3.055Zm5.868,3.181V4.112c0-.747-.259-1-.727-1a1.056,1.056,0,0,0-1.015.979V6.237H18.938V2.394h.943l.048.711a1.645,1.645,0,0,1,1.426-.818c1.027,0,1.4.713,1.4,1.662V6.232H21.729v0h-.016ZM.028,13.607V8.275H1.109v4.487H3.5v.846H.028Zm7.084,0-.036-.613a1.731,1.731,0,0,1-1.428.719,1.874,1.874,0,0,1-1.8-2.025,1.873,1.873,0,0,1,1.8-2.027,1.733,1.733,0,0,1,1.43.72l.036-.614h.933v3.839H7.113ZM5.967,10.426a1.13,1.13,0,0,0-1.092,1.262,1.131,1.131,0,0,0,1.092,1.263,1.13,1.13,0,0,0,1.091-1.263,1.126,1.126,0,0,0-1.088-1.262ZM12.1,13.607l-.036-.613a1.734,1.734,0,0,1-1.428.719,1.874,1.874,0,0,1-1.8-2.025,1.873,1.873,0,0,1,1.8-2.027A1.731,1.731,0,0,1,12,10.292V8.274h1.032v5.333Zm-1.148-3.181a1.13,1.13,0,0,0-1.092,1.262,1.1,1.1,0,1,0,2.184,0A1.129,1.129,0,0,0,10.954,10.426Zm6.137,3.181-.036-.613a1.735,1.735,0,0,1-1.43.719,1.881,1.881,0,0,1-1.813-2.025,1.873,1.873,0,0,1,1.8-2.027,1.731,1.731,0,0,1,1.366.631V8.274H18v5.333h-.918Zm-1.146-3.181a1.13,1.13,0,0,0-1.092,1.262,1.1,1.1,0,1,0,2.184,0,1.128,1.128,0,0,0-1.09-1.262ZM22.4,11.716H19.843a1.151,1.151,0,0,0,1.309,1.25,2.075,2.075,0,0,0,1.245-.453v.737a2.619,2.619,0,0,1-1.564.447,1.965,1.965,0,0,1-2.018-2.054,1.94,1.94,0,0,1,1.934-2.006,1.549,1.549,0,0,1,1.7,1.511,1.978,1.978,0,0,1-.073.534l.016.029Zm-1.616-1.4a.875.875,0,0,0-.9.846h1.644A.694.694,0,0,0,20.786,10.318Zm3.569,1.193v2.1H23.323V9.764h.94l.045.7a1.61,1.61,0,0,1,1.43-.807v1C25.042,10.5,24.354,10.854,24.354,11.51Z"
                                                transform="translate(0 -0.9)"
                                                fill="#2f4858"
                                            />
                                        </g>
                                    </g>
                                </g>
                            </svg>

                            <div className="lg:pl-3 mt-1 lg:mt-0">
                                <h1 className="font-semibold">Brand Name</h1>
                                <p className="text-xs italic">
                                    Blocked on: 12 Jun
                                </p>
                            </div>
                        </div>
                        <div>
                            <button className="bg-primary text-white py-2 px-3 rounded">
                                Unblock
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
            <UploadInvoiceModal
                setInvoiceModalVisibility={setInvoiceModalVisibility}
                isVisible={showInvoiceModal}
                updateInvoice={(f) => updateInvoice(f)}
                loading={updateStatusLoading}
            />
            <NotInterestedModal
                setNotInterestedModalVisibility={
                    setNotInterestedModalVisibility
                }
                showNotInterestedModal={showNotInterestedModal}
                updateStatus={() => updateStatus('NOT_INTERESTED')}
                loading={updateStatusLoading}
                selectedDealId={selectedDealId}
            />
            <SideModal
                visible={showFilterModal}
                onClick={() => setShowFilterModal(false)}
            >
                <div className="flex flex-col content-between h-full">
                    <div className="py-4 pl-6 pr-4">
                        <div className="flex justify-between items-center">
                            <h1 className="font-bold text-lg md:text-2xl lg:text-lg xl:text-2xl">
                                Filters
                            </h1>
                            <GrClose
                                onClick={() => setShowFilterModal(false)}
                                className={` h-4 w-4 cursor-pointer `}
                            />
                        </div>
                        <h3 className="mt-5 text-[#7a7884] font-medium tracking-wider text-xs md:text-sm lg:text-xs xl:text-sm">
                            STATUS
                        </h3>
                        <div className="flex flex-wrap mt-2 gap-x-2 gap-y-2">
                            {statusList.map((status) => (
                                <button
                                    onClick={() =>
                                        onFilterClick({ status: status.id })
                                    }
                                    className={`${
                                        currentFilters.includes(status.id)
                                            ? 'bg-primary text-white'
                                            : 'border-[1.5px] border-[#E3E3E3] bg-[#F0F0F0]'
                                    } text-sm md:text-base lg:text-sm xl:text-base rounded-full font-medium  py-1 px-3`}
                                >
                                    {status.label}
                                </button>
                            ))}
                        </div>
                        <h3 className="mt-5 text-[#7a7884] font-medium tracking-wider text-xs md:text-sm lg:text-xs xl:text-sm">
                            TAGS
                        </h3>
                        <div className="flex flex-wrap gap-x-2 gap-y-2 mt-2">
                            {tags?.map((tag) => (
                                <button
                                    onClick={() => onTagClick(tag.id)}
                                    className={`${
                                        currentTags.includes(tag.id)
                                            ? 'bg-primary text-white'
                                            : 'border-[1.5px] border-[#E3E3E3] bg-[#F0F0F0]'
                                    } text-sm md:text-base lg:text-sm xl:text-base rounded-full font-medium py-1 px-3 `}
                                >
                                    {tag.name}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div></div>
                </div>
            </SideModal>
        </>
    );
}

export default Enquiry;
